import { InjectionToken } from '@angular/core';
import { BaseCountryService } from '../base-classes/base-country.service';

export const COUNTRY_SERVICE_TOKEN = new InjectionToken<BaseCountryService>('COUNTRY_SERVICE');
